import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { colors } from '../../../theme/colors';
import {
  productSrcPlaceHolder,
} from '../../../assets';
import EventEmitter from 'eventemitter3';
import Events from '../../Recommendation/Events';

const Icon = styled.img`
    display: inline;
    width: 140px;
    object-fit: contain;
    align-self: center;
    border-radius: 10px;
    overflow: hidden;
`;

const ArticleData = styled.div`
  display: flex;
  flex-direction: row;
`;

const TextFields = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 20px;
  width: 50%;
  gap: 8px;

  @media (min-width: 761px) {
    width: auto;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const FieldName = styled.span`
  display: inline-block;
  width: 100%;
  color: ${colors['dark-slate-blue']};
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
`;

const FieldValue = styled.span`
  display: inline-block;
  width: 100%;
  max-width: 150px;
  color: #0d3240;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;

  @media (min-width: 761px) {
    max-width: none;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-self: center;
  border-radius: 10px;
  padding: 6px 5px 5px 6px;
  background-color: #f0f0f0;
`;


type Props = {
  articleName?: string,
  manufacturer?: string,
  productSrc?: string,
  matching?: any,
  sum?:any,
  emitter: EventEmitter,
  recommendationPriceEnabled: boolean,
  recommendationMatchingCodeEnabled: boolean,
};

const ArticleInfo: React.FunctionComponent<Props> = (props) => {
  const {
    articleName,
    manufacturer,
    productSrc,
    matching,
    sum,
    emitter,
    recommendationPriceEnabled,
    recommendationMatchingCodeEnabled,
  } = props
  const matchId = matching.matching_id;
  const recommendationCode = matchId.substring(matchId.length - 4);

  return (
      <ArticleData>
        <ImageContainer>
          <Icon src={productSrc !== '' && productSrc !== undefined ? productSrc : productSrcPlaceHolder} />
        </ImageContainer>
        <TextFields>
          <Field>
              <FieldName>
                <FormattedMessage id="drv.matching.article.label"></FormattedMessage>
              </FieldName>
              <FieldValue>{articleName}</FieldValue>
          </Field>
          {sum && recommendationPriceEnabled &&
           <Field>
             <FieldName>
               <FormattedMessage id="drv.matching.price.label"></FormattedMessage>
             </FieldName>
             <FieldValue>{sum}</FieldValue>
          </Field>
          }
          {recommendationMatchingCodeEnabled &&
          <Field>
            <FieldName>
              <FormattedMessage id="drv.matching.code.label"></FormattedMessage>
            </FieldName>
            <FieldValue>{recommendationCode}</FieldValue>
          </Field>
          }
        </TextFields>
      </ArticleData>
  );
};

export default ArticleInfo;
